<div class="employer-contact-card" [formGroup]="formGroup">
  <div class="d-flex justify-content-between gap-4 align-items-center">
    <div class="d-flex flex-column gap-3 flex-grow-1">
      <div class="contact-name">{{ formGroup?.value?.firstName }} {{ formGroup?.value?.lastName }}</div>
      <div class="d-flex gap-2 align-items-center">
        <app-checkbox-input formControlName="hasSigningAuthority" controlId="primaryHasSigningAuthority" />
        <app-form-option-label labelFor="primaryHasSigningAuthority" i18n>Has Signing Authority</app-form-option-label>
      </div>
    </div>
    <div class="d-flex gap-4">
      <button (click)="remove()" type="button" class="no-style-button remove-button" i18n>Remove</button>
      <button
        type="button"
        class="no-style-button text-start w-100"
        [attr.aria-expanded]="isExpanded"
        aria-controls="contactReviewGrid"
        (click)="toggle.emit()">
        <img
          src="/assets/icons/grey/Chevron Down.svg"
          alt=""
          height="24"
          width="24"
          class="chevron-svg"
          aria-hidden="true"
          [class.rotated]="isExpanded" />
      </button>
    </div>
  </div>
  <div id="contactReviewGrid" [ngbCollapse]="!isExpanded">
    <div
      class="collapsible-inner-content"
      role="region"
      [attr.aria-label]="formGroup?.value?.firstName + ' ' + formGroup?.value?.lastName + ' contact details'">
      <div class="add-employer-form-grid">
        <div class="d-flex flex-column gap-1">
          <label class="form-input-label" [for]="'primaryJobTitle'" i18n>Job Title</label>
          <app-text-input
            formControlName="jobTitle"
            controlId="primaryJobTitle"
            [error]="formSubmitted && formGroup.controls.jobTitle.invalid" />
          <div class="form-input-hint" i18n>Optional</div>
        </div>
        <div class="d-flex flex-column gap-1">
          <label [for]="'primaryEmail'" class="form-input-label" i18n>Work Email Address</label>
          <app-email-input
            formControlName="email"
            controlId="primaryEmail"
            [error]="formSubmitted && formGroup.controls.email.invalid" />
          <app-form-error
            *ngIf="formSubmitted && formGroup.controls.email.invalid"
            [customErrorMessages]="customErrorMessages.email"
            [errors]="formGroup.controls.email.errors" />
        </div>
        <div class="d-flex flex-column gap-1">
          <label [for]="'primaryPhoneNumber'" class="form-input-label" i18n>Primary Phone Number</label>
          <app-phone-country-code
            [formGroup]="formGroup"
            [countryCodes]="countryCodeDropdowns$ | async"
            [controlId]="'primaryPhoneNumber'"
            [phoneNumberControlName]="'phoneNumber'"
            [countryCodeControlName]="'phoneNumberCountryCode'" />
          <app-form-error
            *ngIf="formSubmitted && formGroup.controls.phoneNumber.invalid"
            [errors]="formGroup.controls.phoneNumber.errors"
            [customErrorMessages]="customErrorMessages.phoneNumber" />
        </div>
      </div>

      <hr class="contact-divider" />

      <app-international-address-form-grid
        controlIdPrefix="primaryContactAddress"
        [form]="formGroup.controls.address"
        [formSubmitted]="formSubmitted" />
    </div>
  </div>
</div>
